import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { FacilityClass } from "@/js/value-objects/facility-class";
import { FacilityTranslator } from "@/js/translators/facilityTranslator";
const facilityRepository = RepositoryFactory.get("facility");

const state = () => ({
  data: {},
  vulFacilities: {},
  evaFacilities: {}
});
const getters = {};
const mutations = {
  setFacility(state, payload) {
    state.data = payload;
  },
  setVulFacility(state, payload) {
    state.vulFacilities = payload;
  },
  setEvaFacility(state, payload) {
    state.evaFacilities = payload;
  }
};
const actions = {
  async loadFacility(context, payload) {
    const list = await facilityRepository.list(
      payload.screenId,
      payload.municipality,
      payload.facilityClass
    );
    if (list.status < 300) {
      context.commit("setFacility", list.data);
      const vulFacilities = [];
      const evaFacilities = [];
      // TODO あとで整理
      list.data.results.forEach(facilities => {
        Object.keys(facilities).forEach(facilityClass => {
          Object.keys(facilities[facilityClass]).forEach(key => {
            facilities[facilityClass][key].forEach(facility => {
              Object.assign(facility, {
                facility_class: facilityClass
              });
              const facilityClassVo = FacilityClass.factory(facilityClass);
              if (facilityClassVo.isVulnerPeople()) {
                vulFacilities.push(facility);
              } else {
                if (facilityClassVo.isShelter()) {
                  Object.assign(
                    facility,
                    FacilityTranslator.toEveMunicipalitiesAndEveAreasFromEvaAreaInfo(
                      facility.eva_area_info
                    )
                  );
                }
                evaFacilities.push(facility);
              }
            });
          });
        });
      });
      context.commit("setVulFacility", vulFacilities);
      context.commit("setEvaFacility", evaFacilities);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
